import React from 'react';
import Reflux from 'reflux';
import {Link} from 'react-router-dom';

import i18 from '../../../i18';
import {customerApi} from '../../../api';

import DownloadFile from '../../common/DownloadFile';

class Download extends Reflux.Component {
    constructor(props) {
        super(props);

        console.log(props.config)

        this.state = {
            files: [],
            generating: true,
        };
    }

    componentDidMount() {
        void this.generateFiles();
    }

    getCompanyId = () => {
        return this.props.config.company_id;
    };

    getErrorMessage = (error, fallbackMessage) => {
        if (
            error
            && error.response
            && error.response.data
        ) {
            const responseData = error.response.data;

            if (
                responseData.error
                && responseData.error.message
            ) {
                return responseData.error.message;
            }

            if (responseData.message) {
                return responseData.message;
            }
        }

        return fallbackMessage;
    };

    generateFiles = async () => {
        this.setState({
            generating: true,
        });

        try {
            const responseData = await customerApi.generate(
                this.getCompanyId(),
                {
                    invoices: this.props.invoices,
                },
            );

            this.setState({
                files: responseData.files || [],
            });
        } catch (error) {
            this.props.notifyError(
                this.getErrorMessage(
                    error,
                'Hiba történt a feldolgozás során. (#1001)',
                ),
            );
        } finally {
            this.setState({
                generating: false,
            });
        }
    };

    renderFiles = () => {
        if (this.state.generating) {
            return (
                <div className="text-center">
                    <p>A kimeneti fájlok készítése folyamatban...</p>
                </div>
            );
        }

        if (this.state.files.length === 0) {
            return (
                <div className="text-center">
                    <p>Nem készült letölthető fájl.</p>
                </div>
            );
        }

        return (
            <div className="text-center">
                {this.state.files.map((file) => (
                    <DownloadFile
                                key={file.name}
                        title={file.title}
                        name={file.name}
                        url={customerApi.downloadUrl(
                            this.getCompanyId(),
                        )}
                    />
                ))}
            </div>
        );
    };

    render() {
        const processingSuccessful =
            !this.state.generating
            && this.state.files.length > 0;

        return (
            <section id="customer-assignment">
                <div className="col-12">
                    <br />
                    <br />

                    {processingSuccessful
                        ? (
                            <h4>
                                {i18.COMMON._processedSuccessfully}
                            </h4>
                        )
                        : null}

                    <br />

                    {this.renderFiles()}

                    <div className="text-center">
                        <br />
                        <br />

                        <Link to="/">
                            Új feldolgozás indítása
                        </Link>
                    </div>

                    <br />
                    <br />
                </div>
            </section>
        );
    }
}

export default Download;


// WEBPACK FOOTER //
// ./src/components/customer/steps/Download.js